// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__Ju8wF","validationTips":"StatementDescriptor_validationTips__3u1I_"};